export default __webpack_public_path__ + "img/8ce453e52f6b9acc0e899dba155ecffb.svg";